<template>
  <v-container fluid>
    <v-row justify="center">
      <v-col cols="12" xl="4" lg="4" md="4" sm="6" xs="12">
        <v-text-field
          prepend-inner-icon="mdi-magnify"
          outlined
          dense
          :label="translations.label_search_folio"
          background-color="white"
          v-model="folio"
          clearable
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-row no-gutters>
          <v-col
            cols="12"
            xl="4"
            lg="4"
            md="4"
            sm="6"
            xs="12"
            v-for="item in analysis"
            :key="item._id"
          >
            <!-- <span>{{ item.folio }}</span> -->
            <ResultItem :folioAnalysis="item" />
          </v-col>
          <v-row v-if="isFetchingRows">
            <v-col cols="12" v-for="item in 6" :key="item" class="py-2">
              <v-skeleton-loader type="list-item-avatar-three-line" />
            </v-col>
          </v-row>
        </v-row>
      </v-col>
    </v-row>
    <div class="overlayCenter" v-if="!isFetchingRows && analysis.length <= 0">
      <p class="text-center">{{ translations.label_no_results }}</p>
    </div>
    <!-- copyright -->
    <v-footer class=" text-caption text-center d-flex justify-center" fixed>
      D.R. © Solena Ag, Inc. {{new Date().getFullYear()}}
    </v-footer>
  </v-container>
</template>

<script>
// vuex
import { mapState, mapActions, mapMutations, mapGetters } from "vuex";
//components
import ResultItem from "@/components/territory/ResultItem.vue";
export default {
  components: {
    ResultItem,
  },
  data: () => ({
    areaId: null,
    analysis: [],
    currentPage: 1,
    isFetchingRows: false,
    isAllPages: false,
    folio: null,
  }),
  computed: {
    ...mapGetters("session", ["currentTranslations"]),
    translations() {
      return this.currentTranslations;
    },
    ...mapState("areasList", ["areaSelected"]),
  },
  async created() {
    // set tool bar
    this.SET_APPBAR_OPTIONS({
      leftButton: "back-arrow",
      funcLeftButton: this.goBack,
    });
    // get first page in analysis
    await this.loadNextPage();
    // add listener to retrieve next page
    window.addEventListener("scroll", this.handleScroll);
  },
  methods: {
    ...mapActions("samples", ["getAnalysis"]),
    ...mapMutations("alerts", ["SET_ALERT_TYPE"]),
    ...mapMutations(["SET_APPBAR_OPTIONS"]),
    goBack() {
      this.$router.back();
    },
    async handleScroll() {
      const scrollPosition = window.scrollY;
      const windowHeight = window.innerHeight;
      const bodyHeight = document.body.scrollHeight;

      if (scrollPosition + windowHeight >= bodyHeight && !this.loading) {
        await this.loadNextPage();
      }
    },
    async loadNextPage() {
      if (this.isAllPages || this.isFetchingRows) return;
      try {
        this.isFetchingRows = true;
        let clientId = null;
        let user = JSON.parse(localStorage.getItem("user"));
        if (user.role == "ORG_USER" || user.role == "ORG_USER_ADMIN") {
          clientId = localStorage.getItem("organizationId");
          this.SET_APPBAR_OPTIONS({
            leftButton: "menu",
          });
        } else {
          clientId = localStorage.getItem("clientId");
          this.SET_APPBAR_OPTIONS({
            leftButton: "menu_seller",
            funcLeftButton: this.goBack,
          });
        }
        let payload = {
          folio: this.folio,
          client: clientId,
          page: this.currentPage,
        };
        let response = await this.getAnalysis(payload);
        if (response) {
          if (this.currentPage == response.pages) {
            this.isAllPages = true;
          }
          this.currentPage++;
          this.analysis.push(...response.folios);
        } else {
          this.SET_ALERT_TYPE({
            visible: true,
            type: "error",
            text: this.translations.advice_error,
            timeout: 4000,
          });
        }
      } catch (e) {
        console.log(e);
        this.SET_ALERT_TYPE({
          visible: true,
          type: "error",
          text: this.translations.advice_error,
          timeout: 4000,
        });
      }
      this.isFetchingRows = false;
    },
  },
  watch: {
    async folio(value) {
      this.currentPage = 1;
      this.analysis = [];
      this.isAllPages = false;
      await this.loadNextPage();
    },
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  },
};
</script>

<style scoped>
.box-white {
  background-color: white;
}
.overlayCenter {
  display: fixed;
  flex: 100%;
  top: 50%;
  left: 20%;
  right: 20%;
  bottom: 50%;
  z-index: 1;
  position: absolute;
}
</style>
